export default {
  doesIncludeSetpoints: 'Zobraziť každú požadovanú hodnotu s jej toleranciami',
  doesIncludeSignalLegend: 'Uviesť digitálne výstupy a podmienky pod krokmi',
};
